import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import PaymentValidation from '@/components/administration/PaymentValidation';
import BulkCsvPayment from '@/components/administration/BulkCsvPayment';
import ValidationTransactions from '@/components/administration/ValidationTransactions';
import UnidentifiedPayments from '@/components/administration/UnidentifiedPayments';
import { Badge } from '@/components/ui/badge';

async function fetchPendingCount(): Promise<number> {
  try {
    const res = await fetch('/api/treasury/unidentified-payments?status=pending&limit=1', { credentials: 'include' });
    if (!res.ok) return 0;
    const data = await res.json();
    return data.total ?? 0;
  } catch {
    return 0;
  }
}

export default function Administration() {
  const [activeTab, setActiveTab] = useState('payment-validation');

  const { data: pendingCount = 0 } = useQuery({
    queryKey: ['unidentified-payments-count'],
    queryFn: fetchPendingCount,
    refetchInterval: 60000,
  });

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Administración</h1>
        <p className="text-muted-foreground">
          Gestiona validación de pagos y operaciones administrativas
        </p>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-4">
        <TabsList>
          <TabsTrigger value="payment-validation">Validación de Pagos - Alumnos</TabsTrigger>
          <TabsTrigger value="bulk-csv">Validación Masiva (CSV)</TabsTrigger>
          <TabsTrigger value="unidentified" className="flex items-center gap-2">
            Pagos No Identificados
            {pendingCount > 0 && (
              <Badge className="bg-orange-500 text-white text-xs px-1.5 py-0 h-5 min-w-5 rounded-full">
                {pendingCount}
              </Badge>
            )}
          </TabsTrigger>
          <TabsTrigger value="validation-transactions">Transacciones de Validación</TabsTrigger>
        </TabsList>

        <TabsContent value="payment-validation" className="space-y-4">
          <PaymentValidation />
        </TabsContent>

        <TabsContent value="bulk-csv" className="space-y-4">
          <BulkCsvPayment />
        </TabsContent>

        <TabsContent value="unidentified" className="space-y-4">
          <UnidentifiedPayments />
        </TabsContent>

        <TabsContent value="validation-transactions" className="space-y-4">
          <ValidationTransactions />
        </TabsContent>
      </Tabs>
    </div>
  );
}
